import { Container, SimpleGrid } from "@mantine/core"
import { InfoBox } from "@tfg/ui"
import { useParams } from "react-router-dom"

import { PublicResponses } from "@tfg/types/endpoints/public"

import { ProductCard } from "./ProductCards/ProductCard"
import { ProductCardIKKS } from "./ProductCards/ProductCardIKKS"
import { ProductCardIcode } from "./ProductCards/ProductCardIcode"
import { ProductCardJonak } from "./ProductCards/ProductCardJonak"
import { ProductCardOneStep } from "./ProductCards/ProductCardOneStep"

type Props = {
  products: PublicResponses.ProductCard[]
}

export const ProductsGrid = ({ products }: Props) => {
  const params = useParams()
  const displaySlug = params.displaySlug as string

  if (!products.length) {
    return (
      <Container mt="5%">
        <InfoBox message="Aucun produit ne correspond à votre recherche" />
      </Container>
    )
  }

  return (
    <SimpleGrid
      cols={{ base: 2, xs: 2, sm: 3, lg: 4, xl: 5 }}
      spacing={{ base: "lg", sm: "sm", md: "md", lg: "lg" }}
      verticalSpacing={{ base: "lg", sm: "sm", md: "md", lg: "lg" }}
    >
      {products.map((product) => (
        <div key={product.id}>
          <ProductCardContainer
            key={product.agecPopinUrl}
            product={product}
            displaySlug={displaySlug}
          />
        </div>
      ))}
    </SimpleGrid>
  )
}

type ExpertProps = {
  product: PublicResponses.ProductCard
  displaySlug: string
}

export const ProductCardContainer = ({ product, displaySlug }: ExpertProps) => {
  switch (displaySlug) {
    case "jonak": {
      return <ProductCardJonak product={product} />
    }
    case "ikks": {
      return <ProductCardIKKS product={product} />
    }
    case "icode": {
      return <ProductCardIcode product={product} />
    }
    case "onestep": {
      return <ProductCardOneStep product={product} />
    }
    default: {
      return <ProductCard product={product} />
    }
  }
}
